export default "__VITE_ASSET__3a80a63f__"